const baseURL = 'https://fanaticardszone.com/';

export default baseURL;
